import { IMAGE_URL_v4 } from "../../envs/prod/constants";

const teamDetails = [
  {
    twitter: "https://twitter.com/roh__cho",
    linkedin: "https://linkedin.com/in/rohitchoudharydm/",
    title: "Rohit Choudhary",
    designation: "Founder, CEO",
    img: `${IMAGE_URL_v4}/teams/rohit1.webp`,
  },
  {
    twitter: "https://twitter.com/keertay",
    linkedin: "https://linkedin.com/in/keertay-agarwal-90a68156/",
    title: "Keertay Agarwal",
    designation: "Founder, COO",
    img: `${IMAGE_URL_v4}/teams/keerty.webp`,
  },
  {
    twitter: "https://twitter.com/banwani_yash",
    linkedin: "https://linkedin.com/in/yash-banwani-277478a3/",
    title: "Yash Banwani",
    designation: "Founder, CTO",
    img: `${IMAGE_URL_v4}/teams/Yash.webp`,
  },
  {
    twitter: "https://twitter.com/ankit640285",
    linkedin: "https://linkedin.com/in/ankit-bhatia-/",
    title: "Ankit Bhatia",
    designation: "VP - Product",
    img: `${IMAGE_URL_v4}/teams/ankit.webp`,
  },
  {
    twitter: "",
    linkedin: "https://linkedin.com/in/sayagodshala/",
    title: "Saya Godshala",
    designation: "Principal Software Engineer",
    img: `${IMAGE_URL_v4}/teams/saya.webp`,
  },
  {
    twitter: "",
    linkedin: "https://linkedin.com/in/jyoti-pant-b123521a6",
    title: "Jyoti Pant",
    designation: "Associate Product Manager",
    img: `${IMAGE_URL_v4}/teams/Joytip.webp`,
  },
  {
    twitter: "https://twitter.com/CynthiaHaokip",
    linkedin: "https://linkedin.com/in/cynthia-haokip-a5b57abb",
    title: "Cynthia Haokip",
    designation: "VP - Content Operations",
    img: `${IMAGE_URL_v4}/teams/cynthia.webp`,
  },
  {
    twitter: "",
    linkedin: "https://in.linkedin.com/in/akhilendra-singh-9a4888100",
    title: "Akhilendra Singh",
    designation: "Community Manager",
    img: `${IMAGE_URL_v4}/teams/akhil.webp`,
  },
  {
    twitter: "",
    linkedin: "https://linkedin.com/in/neha-bhatia-95b465191",
    title: "Neha Bhatia",
    designation: "Graphic Designer",
    img: `${IMAGE_URL_v4}/teams/neha.webp`,
  },
  {
    twitter: "",
    linkedin: "https://linkedin.com/in/akash-deep-7a513517b/",
    title: "Akash Deep",
    designation: "Senior Software Engineer",
    img: `${IMAGE_URL_v4}/teams/akash.webp`,
  },
  {
    twitter: "https://twitter.com/amxnkumxr",
    linkedin: "https://linkedin.com/in/amankumar--",
    title: "Aman Kumar",
    designation: "General Manager, Strategic Initiatives",
    img: `${IMAGE_URL_v4}/teams/aman.webp`,
  },
  {
    twitter: "",
    linkedin: "https://images.seekhoapp.com/teams/kj.webp",
    title: "Jyoti Sharma",
    designation: "Manager, Finance & Accounts",
    img: `${IMAGE_URL_v4}/teams/Joytij.webp`,
  },
  {
    twitter: "",
    linkedin: "http://linkedin.com/in/simran-barbhuiya",
    title: "Simran Barbhuiya",
    designation: "Manager, Growth & Marketing",
    img: `${IMAGE_URL_v4}/teams/simran.webp`,
  },
  {
    twitter: "https://twitter.com/gautamps25",
    linkedin: "https://linkedin.com/in/gautamps25",
    title: "Gautam PS",
    designation: "VP - Growth & Marketing",
    img: `${IMAGE_URL_v4}/teams/gautam.webp`,
  },
  {
    twitter: "https://x.com/_iam_ak__/",
    linkedin: "https://linkedin.com/in/heyabrar/",
    title: "Abrar Khan",
    designation: "Software Engineer",
    img: `${IMAGE_URL_v4}/teams/abrar.webp`,
  },
  {
    twitter: "",
    linkedin: "https://linkedin.com/in/vaibhav-varshney-7919a0219/",
    title: "Vaibhav Varshney",
    designation: "Software Engineer",
    img: `${IMAGE_URL_v4}/teams/vaibhav.webp`,
  },
  {
    twitter: "",
    linkedin: "https://linkedin.com/in/satyaiyengar/",
    title: "Satya Iyengar",
    designation: "Senior Software Engineer",
    img: `${IMAGE_URL_v4}/teams/satya.webp`,
  },
  {
    twitter: "",
    linkedin: "https://linkedin.com/in/gauravsharma108",
    title: "Gaurav Sharma",
    designation: "Senior Product Manager",
    img: `${IMAGE_URL_v4}/teams/gaurav.webp`,
  },
  {
    twitter: "",
    linkedin: "https://linkedin.com/in/chiragsabhadiya",
    title: "Chirag Sabhadiya",
    designation: "Content Operations Manager",
    img: `${IMAGE_URL_v4}/teams/chirag.webp`,
  },
  {
    twitter: "",
    linkedin: "https://linkedin.com/in/payal-sharma-607117223",
    title: "Payal Sharma",
    designation: "Executive Assistant",
    img: `${IMAGE_URL_v4}/teams/payal.webp`,
  },
  {
    twitter: "",
    linkedin: "https://linkedin.com/in/himanshu-gautam-0b40b189",
    title: "Himanshu Gautam",
    designation: "Director, Content Operations",
    img: `${IMAGE_URL_v4}/teams/himanshu.webp`,
  },
  {
    twitter: "",
    linkedin: "https://linkedin.com/in/vaibhavrana09",
    title: "Vaibhav Rana",
    designation: "Customer Experience Manager",
    img: `${IMAGE_URL_v4}/teams/vaibhav-rana.webp`,
  },
  {
    twitter: "",
    linkedin: "https://www.linkedin.com/company/seekhoo",
    title: "Abhishek Khandelwal",
    designation: "Senior Manager, Content Operations",
    img: `${IMAGE_URL_v4}/teams/abhishek.webp`,
  },
  {
    twitter: "",
    linkedin: "https://www.linkedin.com/in/parulsingh302001",
    title: "Parul Singh",
    designation: "Associate, Growth & Marketing",
    img: `${IMAGE_URL_v4}/teams/parul.webp`,
  },
  {
    twitter: "",
    linkedin: "https://www.linkedin.com/in/sneha-d-0abb6820a",
    title: "Sneha Dutta",
    designation: "Content Operations Associate",
    img: `${IMAGE_URL_v4}/teams/sneha.webp`,
  },
  {
    twitter: "",
    linkedin: "https://www.linkedin.com/in/gauri-ninawe-001654177",
    title: "Gauri Ninawe",
    designation: "Manager, Growth & Marketing",
    img: `${IMAGE_URL_v4}/teams/gauri.webp`,
  },
  {
    twitter: "",
    linkedin: "https://www.linkedin.com/in/shivam-maheshwari1",
    title: "Shivam Maheshwari",
    designation: "Senior Software Engineer",
    img: `${IMAGE_URL_v4}/teams/shubham.webp`,
  },
  {
    twitter: "",
    linkedin: "https://www.linkedin.com/in/princepatoliya",
    title: "Prince Patoliya",
    designation: "Software Engineer",
    img: `${IMAGE_URL_v4}/teams/prince.webp`,
  },
  {
    twitter: "",
    linkedin: "https://www.linkedin.com/in/saravanan-k-8b5254187",
    title: "Saravanan K",
    designation: "Content Operations Associate",
    img: `${IMAGE_URL_v4}/teams/sarvanan.webp`,
  },
  {
    twitter: "",
    linkedin: "https://www.linkedin.com/in/madhushri-hm-719232172",
    title: "Madhushri",
    designation: "Content Manager",
    img: `${IMAGE_URL_v4}/teams/madhushree.webp`,
  },
  {
    twitter: "",
    linkedin: "https://www.linkedin.com/in/prince-raj1/",
    title: "Prince Raj",
    designation: "Associate Director",
    img: `${IMAGE_URL_v4}/teams/arthav.webp`,
  },
  {
    twitter: "",
    linkedin: "https://www.linkedin.com/in/abhishek-mohapatra-5b1655189",
    title: "Abhishek Mohapatra",
    designation: "Content Moderation Associate",
    img: `${IMAGE_URL_v4}/teams/abhishek_mohapatra.webp`,
  },
  {
    twitter: "",
    linkedin: "https://www.linkedin.com/in/ritikamalik29",
    title: "Ritika Malik",
    designation: "Product Manager",
    img: `${IMAGE_URL_v4}/teams/ritika.webp`,
  },
  {
    twitter: "",
    linkedin: "https://www.linkedin.com/in/jenita-satra",
    title: "Jenita Satra",
    designation: "Lead Graphic Designer",
    img: `${IMAGE_URL_v4}/teams/jenita.webp`,
  },
  {
    twitter: "",
    linkedin: "https://www.linkedin.com/in/abhaypratapjakhar",
    title: "Abhay Pratap Jakhar",
    designation: "Growth Associate",
    img: `${IMAGE_URL_v4}/teams/abhay.webp`,
  },
  {
    twitter: "",
    linkedin: "https://www.linkedin.com/in/mukesheswaran",
    title: "Mukesh Eswaran",
    designation: "Senior Business Analyst",
    img: `${IMAGE_URL_v4}/teams/Frame.webp`,
  },
  {
    twitter: "",
    linkedin: "https://www.linkedin.com/in/akash-chaudhary-4b684b171",
    title: "Akash Chaudhary",
    designation: "Product Manager",
    img: `${IMAGE_URL_v4}/teams/Frame.webp`,
  },
  {
    twitter: "",
    linkedin: "https://www.linkedin.com/in/vivek-sharma05",
    title: "Vivek Sharma",
    designation: "Product Designer",
    img: `${IMAGE_URL_v4}/teams/Frame.webp`,
  },
  {
    twitter: "",
    linkedin: "",
    title: "See yourself here?",
    designation: "",
    img: `${IMAGE_URL_v4}/teams/Frame.webp`,
  },
];

export { teamDetails };
